async function getLatestRelease(owner, repo) {
  const res = await fetch(`https://api.github.com/repos/${owner}/${repo}/releases/latest`);
  if (!res.ok) {
    throw new Error('Không lấy được bản release mới nhất');
  }
  const data = await res.json();
  const asset = data.assets?.[0];
  if (!asset) {
    throw new Error('Release chưa có file đính kèm');
  }
  return {
    tag: data.tag_name,
    publishedAt: data.published_at,
    downloadUrl: asset.browser_download_url,
    assetName: asset.name,
    size: asset.size,
  };
}

const github = { getLatestRelease };

export default github;
